module.exports = __webpack_public_path__ + "fonts/1cf51cad3791fd41e76bb32b5b90ca10.svg";